import React, { useState, useMemo } from 'react';
import Select from 'v3/components/Select';
import SelectBusinessGroupModal from './modal';
import Link from '../Link';

export default function SelectBusinessGroup({
	label,
	placeholder = 'Selecione um grupo...',
	value,
	onChange,
	onSearch,
	multiple = false,
	horizontal = false,
	error,
	isDisabled = false,
	loading = false,
	getOptionLabel = option => option?.principal?.label,
	getOptionValue = option => option.id,
}) {
	const [showCnpjsModal, setShowCnpjsModal] = useState(false);

	const hasValue = useMemo(() => {
		if (multiple) {
			return Array.isArray(value) && value.length > 0;
		}
		return !!value;
	}, [value, multiple]);

	const selectedGroups = useMemo(() => {
		if (multiple) {
			return Array.isArray(value) ? value : [];
		}
		return value ? [value] : [];
	}, [value, multiple]);

	const hasChildren = useMemo(() => {
		return selectedGroups.some(
			group => group.persons && group.persons.length > 0
		);
	}, [selectedGroups]);


	return (
		<>
			<SelectBusinessGroupModal
				showCnpjsModal={showCnpjsModal}
				onClose={() => setShowCnpjsModal(false)}
				setShowCnpjsModal={setShowCnpjsModal}
				groups={selectedGroups}
			/>
				<Select.Async
					label={label}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					onSearch={onSearch}
					multiple={multiple}
					horizontal={horizontal}
					error={error}
					isDisabled={isDisabled}
					loading={loading}
					getOptionLabel={getOptionLabel}
					getOptionValue={getOptionValue}
				/>
				{hasValue && hasChildren && (
					<Link
						withoutIcon
						onClick={(e) => {
							e.preventDefault();
							setShowCnpjsModal(true);
						}}
						className="text-right mt-1 d-block"
						style={{
							textDecoration: 'underline',
						}}
					>
						visualizar cnpj's
					</Link>
				)}
		</>
	);
}
